(function () {
  function removeDuplicateHeaders() {
    var headers = document.querySelectorAll('#shopify-section-header');
    if (!headers || headers.length <= 1) return;

    // Keep the first one in the DOM, remove the rest
    for (var i = 1; i < headers.length; i++) {
      if (headers[i] && headers[i].parentNode) {
        headers[i].parentNode.removeChild(headers[i]);
      }
    }
  }

  // Run ASAP
  removeDuplicateHeaders();

  // Run after load
  window.addEventListener('load', function () {
    removeDuplicateHeaders();
    setTimeout(removeDuplicateHeaders, 100);
    setTimeout(removeDuplicateHeaders, 500);
    setTimeout(removeDuplicateHeaders, 1500);
  });

  // Shopify section editor events (important)
  document.addEventListener('shopify:section:load', removeDuplicateHeaders);
  document.addEventListener('shopify:section:reorder', removeDuplicateHeaders);
  document.addEventListener('shopify:section:select', removeDuplicateHeaders);

  // Brutal but effective fallback if something keeps re-inserting it
  var tries = 0;
  var interval = setInterval(function () {
    removeDuplicateHeaders();
    tries++;
    if (tries > 50) clearInterval(interval); // ~10 seconds total
  }, 200);
})();